import { render, staticRenderFns } from "./Conversions.vue?vue&type=template&id=0fc95cb8&scoped=true"
import script from "./Conversions.vue?vue&type=script&lang=js"
export * from "./Conversions.vue?vue&type=script&lang=js"
import style0 from "./Conversions.vue?vue&type=style&index=0&id=0fc95cb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc95cb8",
  null
  
)

export default component.exports